import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Typography,
  Button,
  message,
  Divider,
  Table,
  Input,
  Tooltip,
  Form,
  Modal,
  Tag,
  Space,
  DatePicker,
  Alert,
} from "antd";
import { EditOutlined, SearchOutlined, FileSearchOutlined, UserOutlined, BarsOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams } from "react-router-dom";
import http from "../../../services/http";
import dayjs from "dayjs";
const { Text } = Typography;

export const PdiGestaoAcoes = () => {
  const navigate = useNavigate();
  const { id_competencia, id_colaborador, id_pdi } = useParams();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModalDetalhes, setShowModalDetalhes] = useState(false);

  // ID ALTERAÇÃO
  const [idAlt, setIdAlt] = useState(0);
  const [search, setSearch] = useState("");

  const [competencia, setCompetencia] = useState({});
  const [colaborador, setColaborador] = useState({});
  const [acao, setAcao] = useState(null);

  useEffect(() => {
    if ((id_competencia, id_colaborador)) {
      carregarPdiCompetencia(id_competencia);
      listarPdisAcoes(id_competencia);
      carregarColaborador(id_colaborador);
    }
  }, [id_colaborador, id_competencia]);

  // CARREGAR COLABORADOR
  const carregarColaborador = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/avaliacoes_pdis_liberacoes/carregar_colaborador/${id}`, []);
    if (api.statusCode === 200) {
      if (!api?.response?.data) {
        navigate("/pdi/colaboradores");
      }
      setColaborador(api?.response?.data);
    } else {
      navigate("/pdi/colaboradores");
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CARREGAR
  const carregarPdiCompetencia = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/pdi_competencias/carregar/${id}`, []);
    if (api.statusCode === 200) {
      if (api?.response?.data) {
        setCompetencia(api?.response?.data);
      } else {
        navigate("/pdi/colaboradores");
      }
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CARREGAR
  const carregarPdiAcaoDetalhado = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/pdi_acoes/carregar_detalhes/${id}`, []);
    if (api.statusCode === 200) {
      if (api?.response?.data) {
        setShowModalDetalhes(true);
        setAcao(api?.response?.data);
      }
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // LISTAR
  const listarPdisAcoes = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/pdi_acoes/listar/${id}`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data);
    } else {
      navigate("/pdi/colaboradores");
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // AVALIAR
  const avaliarPdiAcao = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/pdi_acoes/avaliar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro alterado com sucesso!");
      setShowModal(false);
      resetForm();
      listarPdisAcoes(id_competencia);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CARREGAR
  const carregarPdiAcao = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/pdi_acoes/carregar/${id}`, []);
    if (api.statusCode === 200) {
      if (api?.response?.data) {
        setShowModal(true);
        resetForm();
        form.setFieldsValue({
          descricao: api?.response?.data?.descricao,
          observacoes: api?.response?.data?.observacoes,
          data_maxima_realizacao: dayjs(api?.response?.data?.data_maxima_realizacao),
        });
        setIdAlt(api.response.data.id);
      }
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // RESET FORM
  const resetForm = () => {
    form.resetFields();
    setIdAlt(0);
  };

  // COLUNAS TABLE
  const columns = [
    {
      dataIndex: "descricao",
      title: "Ação",
      sorter: (a, b) => a.descricao?.localeCompare(b.descricao),
    },
    {
      dataIndex: "observacoes",
      title: "Obs/Como?",
      sorter: (a, b) => a.descricao?.localeCompare(b.descricao),
    },
    {
      dataIndex: "data_maxima_realizacao",
      title: "Prazo",
      width: 100,
      render: (_, e) => dayjs(e.data_maxima_realizacao).format("DD/MM/YYYY"),
      sorter: (a, b) =>
        dayjs(a.data_maxima_realizacao)
          .format("DD/MM/YYYY")
          ?.localeCompare(dayjs(b.data_maxima_realizacao).format("DD/MM/YYYY")),
    },
    {
      key: "status",
      title: "Status",
      width: 100,
      render: (_, e) => (e.status === 1 ? <Tag color="green">Concluído</Tag> : <Tag color="red">Pendente</Tag>),
      sorter: (a, b) =>
        (a.status === 1 ? "Concluído" : "Pendente")?.localeCompare(b.status === 1 ? "Concluído" : "Pendente"),
    },
    {
      key: "acoes",
      title: "Ações",
      width: 70,
      render: (_, e) => (
        <Space.Compact>
          <Tooltip title="Detalhes">
            <Button loading={loading} onClick={() => carregarPdiAcaoDetalhado(e.id)} icon={<BarsOutlined />} />
          </Tooltip>
          {e.status === 0 && (
            <Tooltip title="Avaliar">
              <Button loading={loading} onClick={() => carregarPdiAcao(e.id)} icon={<EditOutlined />} />
            </Tooltip>
          )}
        </Space.Compact>
      ),
    },
  ];

  // SUBMIT FORM
  const onSubmit = (formulario) => {
    if (idAlt > 0) {
      formulario.id = idAlt;
      avaliarPdiAcao(formulario);
    }
  };

  // PESQUISAR
  const handleFilter = (pesquisar) => {
    let filteredData = dados?.filter(
      (val) =>
        val.descricao?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.observacoes?.toString()?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        dayjs(val.data_maxima_realizacao)?.format("DD/MM/YYYY")?.toLowerCase().includes(pesquisar.toLowerCase())
    );
    return filteredData;
  };

  const dadosFilter = dados?.length > 0 ? handleFilter(search) : [];

  // FORMULÁRIO
  const modalFormulario = () => {
    return (
      <Modal
        title={
          <Text style={{ fontSize: 20 }}>
            <EditOutlined /> Avaliar Ação
          </Text>
        }
        open={showModal}
        onOk={() => form.submit()}
        okText="Salvar"
        width={1200}
        okButtonProps={{ size: "large", loading: loading }}
        cancelButtonProps={{ size: "large", loading: loading }}
        onCancel={() => {
          setShowModal(false);
          resetForm();
        }}>
        <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="descricao" label="Descrição">
                <Input className="read-only" size="large" disabled={true} />
              </Form.Item>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="data_maxima_realizacao" label="Prazo Realização">
                <DatePicker
                  className="read-only"
                  format={"DD/MM/YYYY"}
                  style={{ width: "100%" }}
                  size="large"
                  disabled={true}
                />
              </Form.Item>
            </Col>

            <Col className="gutter-row" span={24}>
              <Form.Item name="observacoes" label="Obs/Como?">
                <Input.TextArea
                  className="read-only"
                  size="large"
                  disabled={true}
                  rows={6}
                  autoSize={{ minRows: 5, maxRows: 7 }}
                />
              </Form.Item>
            </Col>

            <Col className="gutter-row" span={24}>
              <Form.Item
                name="parecer_retorno"
                label="Parecer de Conclusão"
                rules={[{ required: true, message: "Informe as observações!" }]}>
                <Input.TextArea
                  size="large"
                  disabled={loading}
                  placeholder="Informe as observações"
                  rows={6}
                  autoSize={{ minRows: 5, maxRows: 7 }}
                />
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={24}>
              <Alert
                message="Ao salvar, esta ação será marcada como concluída e não poderá ser alterada novamente!"
                type="info"
                showIcon
              />
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  };

  // RENDER ITEM
  const RenderItem = ({ titulo, descricao }) => {
    return (
      <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12} style={{ marginBottom: 20 }}>
        <Space direction="vertical" size={0}>
          <Text type="secondary" style={{ fontSize: 14 }}>
            {titulo}
          </Text>
          <Text style={{ fontSize: 16 }}>{descricao ?? "-"}</Text>
        </Space>
      </Col>
    );
  };

  // FORMULÁRIO
  const modalDetalhes = () => {
    return (
      <Modal
        title={<Text style={{ fontSize: 20 }}>{acao?.competencia}</Text>}
        open={showModalDetalhes}
        width={800}
        cancelText="Fechar"
        okButtonProps={{ style: { display: "none" } }}
        cancelButtonProps={{ loading: loading, type: "primary" }}
        onCancel={() => {
          setShowModalDetalhes(false);
          setAcao(null);
        }}>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <RenderItem titulo="Ação" descricao={acao?.descricao ?? ""} />
          <RenderItem titulo="Observações" descricao={acao?.observacoes ?? ""} />
          <RenderItem titulo="Data Prazo" descricao={dayjs(acao?.data_maxima_realizacao).format("DD/MM/YYYY") ?? ""} />
          {acao?.status === 1 && (
            <React.Fragment>
              <Divider />
              <RenderItem titulo="Avaliador" descricao={acao?.avaliador ?? ""} />
              <RenderItem titulo="Parecer Retorno" descricao={acao?.parecer_retorno ?? ""} />
              <RenderItem titulo="Data Parecer" descricao={dayjs(acao?.data_retorno).format("DD/MM/YYYY") ?? ""} />
            </React.Fragment>
          )}
        </Row>
      </Modal>
    );
  };

  return (
    <Row align="middle" justify="center" className="content-row">
      {modalFormulario()}
      {modalDetalhes()}
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage
              title="PDI"
              onClickBack={() => navigate(`/pdi/colaboradores/pdis/${id_colaborador}/competencias/${id_pdi}`)}
            />
            <HeaderTitle
              title="PDI Competências - Ações Gestão"
              subtitle={
                <Text italic>
                  <UserOutlined /> {`${colaborador?.matricula ?? ""} - ${colaborador?.nome ?? ""}`}
                </Text>
              }
              icon={<FileSearchOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Space direction="vertical" size={20}>
                <Space direction="vertical" size={0}>
                  <Text style={{ fontSize: 12 }} type="secondary">
                    Competência a ser desenvolvida:
                  </Text>
                  <Text style={{ fontSize: 14 }} strong>
                    {competencia?.descricao}
                  </Text>
                </Space>
                <Space wrap>
                  <Input
                    size="middle"
                    maxLength={100}
                    prefix={<SearchOutlined />}
                    className="input"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Pesquisar..."
                    allowClear
                  />
                </Space>
              </Space>

              <Divider />

              <Table
                loading={loading}
                scroll={{ x: 700 }}
                columns={columns}
                dataSource={dadosFilter}
                size="small"
                rowKey="id"
              />
            </Card>
          </div>
        </Col>
      </Col>
    </Row>
  );
};
